export { default as default } from '../modules/react/Input.js'


//////////////////
// WEBPACK FOOTER
// ./node_modules/input-format/react/index.js
// module id = 812
// module chunks = 0